<script setup lang="ts">
import { useData } from "vitepress";
import { type Component, computed } from "vue";
import HomePage from "../features/content/HomePage.vue";
import ContentIndexLayout from "../layouts/ContentIndexLayout.vue";
import ContentLayout from "../layouts/ContentLayout.vue";
import DefaultPageLayout from "../layouts/DefaultPageLayout.vue";
import ProjectLayout from "../layouts/ProjectLayout.vue";

const { frontmatter } = useData();

const layout = computed(() => frontmatter.value.layout);

// Map layout names to components
const layoutComponents: Record<string, Component> = {
  home: HomePage,
  default: DefaultPageLayout,
  content: ContentLayout,
  "content-index": ContentIndexLayout,
  project: ProjectLayout,
};

const currentLayout = computed(() => {
  const layoutName = layout.value || "default";
  return layoutComponents[layoutName] || DefaultPageLayout;
});
</script>

<template>
  <component :is="currentLayout" />
</template>
